exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".emoji[data-v-5f299a28]{position:absolute;bottom:51px;right:0;white-Space:normal;z-index:20}\n", ""]);

